import { useMutation, useQueryClient } from 'react-query';
import { removeRosterFunctions } from 'RestAPIs/roster/functions';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

type RemoveRosterFunctionVariables = {
  costCenterId: number;
  functionId: number;
};

const useRemoveRosterFunctions = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, RemoveRosterFunctionVariables>(
    ({ costCenterId, functionId }) =>
      removeRosterFunctions(costCenterId, functionId),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries([
          'rosterFunctions',
          'list',
          variables.costCenterId
        ]);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useRemoveRosterFunctions;
